import React, { useEffect, useState } from 'react';
import './SplashScreen.css';
import logoImagotipo from '../../assets/img/imagotipo-logo.png';

const SplashScreen = ({ finishLoading }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [lightPosition, setLightPosition] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        finishLoading();
      }, 800);
    }, 3500);

    // Opcional: Para controlar la posición de la luz
    const lightInterval = setInterval(() => {
      setLightPosition(prev => (prev + 1) % 100);
    }, 30);
    
    return () => {
      clearTimeout(timer);
      clearInterval(lightInterval);
    };
  }, [finishLoading]);

  return (
    <div className={`splash-container ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        
        {/* SVG para clip-path (opcional, para mejor recorte) */}
        <svg width="0" height="0" style={{position: 'absolute'}}>
          <defs>
            <clipPath id="logo-clip" clipPathUnits="objectBoundingBox">
              {/* Aquí deberías poner el path de tu logo en coordenadas normalizadas (0-1) */}
              {/* Esto es un ejemplo placeholder - necesitas el path real de tu logo */}
              <path d="M0.1,0.1 L0.9,0.1 L0.9,0.9 L0.1,0.9 Z" />
            </clipPath>
          </defs>
        </svg>
        
        <div className="logo-wrapper">
          {/* Sombras dinámicas */}
          <div className="dynamic-shadow"></div>
          
          {/* Rayos de luz de fondo */}
          <div className="light-rays"></div>
          
          {/* Brillo general */}
          <div className="logo-glow"></div>
          
          {/* Logo principal */}
          <img 
            src={logoImagotipo} 
            alt="Logo Carnes Clavelina" 
            className="splash-logo-img"
            style={{
              // Opcional: efecto dinámico basado en posición de luz
              filter: `brightness(${0.85 + Math.sin(lightPosition * 0.1) * 0.2})`
            }}
          />
          
          {/* Reflejo del logo */}
          <div className="logo-reflection"></div>
          
          {/* Efecto principal: luz pasando por encima */}
          <div className="knife-light-overlay"></div>
          
          {/* Punto focal de la luz (opcional) */}
          <div 
            className="light-spot"
            style={{
              position: 'absolute',
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%)',
              left: `${lightPosition}%`,
              top: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.3,
              filter: 'blur(5px)',
              zIndex: 2,
              pointerEvents: 'none'
            }}
          ></div>
        </div>
        
        <div className="loading-container">
          <div className="loading-bar-red"></div>
          <p className="loading-text">CLAVELINA CARNES</p>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;